<template>
  <div style="background: rgb(8, 33, 64)"
    :style="{ 'background': (templateModel != null ? templateModel.background : '#000000') }">
    <div id="channel-list-page-wrap">
      <div class="channel-list-page">
        <img class="banner-img" v-show="templateModel != null && templateModel.topPictureUrl != ''"
          :src="templateModel.topPictureUrl">
        <div class="channel-list-box">
          <!-- 板块 -->
          <div class="menu" v-for="(item, index) in templateModel.detaillist" :key="index"
            :style="{ 'background': 'linear-gradient(to right,' + (templateModel != null ? templateModel.color : '#000000') + ',transparent)' }">
            <img class="logo" v-show="item.logoUrl != null && item.logoUrl != ''" :src="item.logoUrl">
            <p class="title">{{ item.mainTitle }}</p>
            <p class="time" v-show="item.subtitle != ''">
              <i class="iconfont" style="color:#082140;opacity:0.4;">
                |
              </i>
              <span>{{ item.subtitle }}</span>
            </p>
            <a href="javascript:0" class="btn" @click="liveclk(item)"
              style="border:1px solid #0081c9;color:#0081c9;box-shadow:0 0 10px #0081c9;">{{ item.buttonText }}</a>
          </div>

        </div>
        <img class="bottom-img" v-show=" templateModel!=null && templateModel.bottomPictureUrl"
          :src="templateModel.bottomPictureUrl">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "channelList",
  data() {
    return {
      Id: 0,//直播列表id
      templateModel: {},
      type: 0,  //1目睹2获得场景
      mtgId: 0
    }
  },
  methods: {
    //直播按钮事件
    liveclk(item) {
      // if (this.type == 1) {
        const { href } = this.$router.resolve({
          path: '/muduLive?',
          query: {
            id: item.liveID,
            mid: this.mtgId
          }
        });
        window.open(href, '_blank');
      // } else {
      //   const { href } = this.$router.resolve({
      //     path: '/huodeLive?',
      //     query: {
      //       id: item.liveID,
      //       mid: this.mtgId
      //     }
      //   });
      //   window.open(href, '_blank');
      // }

    },
    //获取直播模板列表
    GetLiveTemplateList() {
      let _this = this;
      _this.httphelper.post('/api/LiveApi/GetLiveTemplateList', {
        Id: parseInt(this.Id),
      }).then(res => {
        if (res.data.code == 200) {
          let data = res.data.data;
          _this.templateModel = data;
          document.title = res.data.data.title || '全科医学网'
        }
      });
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    }
  },
  created() {
    if (this.isMobile()) {
      this.$router.push({
        path: '/channelListMobile',
        query: {
          Id: this.$route.query.Id,
          type: this.$route.query.type,
          mid: this.$route.query.mid
        }
      });
    } else {


      if (this.$route.query.mid != '' && this.$route.query.mid != null) {
        this.mtgId = this.$route.query.mid;
      }
      let _this = this
      _this.Id = this.$route.query.Id
      //1目睹2获得场景
      _this.type = this.$route.query.type
    }

  },
  mounted() {
    //获取模板列表
    this.GetLiveTemplateList();

  }
}
</script>
 

<style scoped>
img {
  width: 100%;
}

.menu {
  position: relative;
  margin: 1rem;
  padding: 1px;
  height: 7.1rem;
}

.menu .logo {
  float: left;
  margin: 1.3rem;
  width: 4.5rem;
  height: 4.5rem;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.menu .title {
  margin-top: 1.9rem;
  margin-left: 1.6rem;
  margin-bottom: 1rem;
  line-height: 1.8rem;
  font-size: 1.3rem;
  color: #f3f5ff;
  margin-right: 8.3rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.menu .btn {
  position: absolute;
  display: inline-block;
  right: 1.3rem;
  top: 50%;
  margin-top: -1.425rem;
  width: 6.7rem;
  height: 2.85rem;
  line-height: 2.85rem;
  text-align: center;
  font-size: 1.35rem;
  color: #6babff;
  border: 1px solid #6babff;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  border-radius: 1.5rem;
}

a {
  text-decoration: none;
}

.menu .time {
  position: relative;
  margin-left: 1.6rem;
  margin-right: 8.3rem;
  line-height: 1.2;
  overflow: hidden;
}

.menu .time i {
  position: absolute;
  left: 0;
  display: inline-block;
  font-size: 1.3rem;
  color: #713a9c;
  vertical-align: top;
}

.iconfont {
  font-family: 'iconfont' !important;
  cursor: pointer;
  font-style: normal;
  font-size: 16px;
}

.menu .time span {
  display: inline-block;
  width: 100%;
  padding-left: 1.3rem;
  font-size: 1.3rem;
  color: #fff;
  opacity: 0.6;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
 


